module.exports = __webpack_public_path__ + "img/section3_icon1_m.156e0dcf.png";